import { Api } from 'utils';

class OperatorService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/operators/get',params),
		getServices: async (params?: any) => Api.createResponse('admin/operators/get-services',params),
		create: async (params?: any) => Api.createResponse('admin/operators/create',params),
		update: async (params?: any) => Api.createResponse('admin/operators/update',params),
		delete: async (params?: any) => Api.createResponse('admin/operators/delete',params),
		bulkDelete: async (params?: any) => Api.createResponse('admin/operators/bulk-delete',params),
	}

}

export default OperatorService;